export const ROLE_CONFIG: Record<string, { label: string; color: string }> = {
  owner: { label: 'Dono', color: 'primary.500' },
  admin: { label: 'Admin', color: 'blue.600' },
  member: { label: 'Membro', color: 'gray.600' },
}
